import React, { useState } from 'react'
import OTPInput from '../elements/form/OtpInput'
import { authHeader } from '../../utils'
import axios from 'axios'
import { ERROR, SET_SUCCESS } from '../../store/types'
import { useDispatch } from 'react-redux'
import ModalActionButton from '../elements/ModalActionButton'

const ConfirmTransferFromWallet = ({transferData, reload, close}) => {
    const [otp, setOtp] = useState('')
    const [processing, setProcessing] = useState(false)

    const dispatch = useDispatch()

    const confirmPaymentFromWallet = async () => {
        try {
            const headers = authHeader()

            const paymentPayload = {
                confirmationCode: otp
            }
            setProcessing(true)
            await axios.post(`${process.env.REACT_APP_BASE_URL}/payments/confirm-payment/wallet`, paymentPayload, { headers })           
            
            setProcessing(false)
            dispatch({
                type: SET_SUCCESS,
                payload: 'Transfer Queued Successfully!'
            })

            reload()
            close()
        } catch (error) {
            console.log(error)
            setProcessing(false)
            dispatch({
                type: ERROR,
                error
            })
        }
    }

    return (
        <div className='w-full'>
            <p className='mb-[20px] text-sm text-gray-600'>Please use the OTP sent to your email below to confirm payment of <span className='font-[550] text-vcm-purple text-[16px] font-space-grotesk'>₦{(transferData?.amount/100).toLocaleString()}</span> for invoice <span className='font-[550] text-vcm-purple'>{transferData.invoiceName}({transferData?.invoiceCode})</span></p>
            <div className='mx-auto w-[80%] flex items-center justify-center mb-[20px]'>
                <OTPInput length={6} onChange={(value)=>{setOtp(value)}} />
            </div>

            <div className="mt-8 flex flex-row-reverse gap-x-4">
                <ModalActionButton
                    buttonLabel={`Conirm payment`}
                    buttonAction={()=>{confirmPaymentFromWallet()}}
                    processing={processing}
                />
                <button
                    type="button"
                    className="inline-flex justify-center px-5 py-4 text-xs font-medium bg-transparent border border-transparent rounded-md hover:bg-opacity-50 hover:bg-secondary focus:outline-none"
                    onClick={close}
                >
                    Cancel
                </button>
                
            </div>
        </div>
    )
}

export default ConfirmTransferFromWallet